import styled from 'styled-components';
import themeHelper from '../../../utils/themeHelper';

export const ModalContent = styled.div`
  min-width: 85vw;
`;

export const VideoContainer = styled.div`
  padding: ${themeHelper.spacing(0.25, 0)};
`;

export const Container = styled(VideoContainer)`
  border: 1px solid ${({ theme }) => theme.colours.layering[0].main};
  padding: ${themeHelper.spacing(0.5)};
  display: flex;
  flex-direction: column;
  gap: ${themeHelper.spacing(1)};
`;

export const GridContainer = styled(VideoContainer)`
  display: flex;
  flex-direction: column;
  gap: ${themeHelper.spacing(1)};
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${themeHelper.spacing(0.5)};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const TextArea = styled.textarea`
  width: 100%;
  background-color: ${({ theme }) => theme.colours.canvas.secondary.main};
  padding: ${themeHelper.spacing(0.5)};
`;
